import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import { advisorPlanStartPath } from 'Consts/Strings';
import Start from './Start';

const mapStateToProps = state => ({
  plan: state.plan,
});

const ExternalPlanBased = ({ plan: { id } }) => (
  <div>
    {!id ? (
      <Start />
    ) : (
      <>
        <Route exact path={advisorPlanStartPath} component={Start} />
      </>
    )}
  </div>
);

ExternalPlanBased.propTypes = {
  plan: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default connect(mapStateToProps)(withRouter(ExternalPlanBased));
